//later on, we can keep one database, and have multiple keys for searching and filtering (men, women, kids), (sports, formal, fashion, beach), (footwear, shirts, watches), (brand names), etc...
//and then use graphQL queries probably to find out suitable

export const MensData = [
  {
    imgUrl:
      "https://www.soccerbible.com/media/19123/adidas-messi-10-10-img1.jpg",
    brandName: "Adidas",
    description: "Men Football Shoes",
    price: "Rs. 14200",
    size: "S, M, L, XL, XLL",
  },
  {
    imgUrl:
      "https://www.soccerbible.com/media/101280/every-cr7-nike-signature-mercurial-2.jpg",
    brandName: "Nike",
    description: "Men Football Shoes",
    price: "Rs. 19200",
    size: "S, M, L, XL, XLL",
  },
  {
    imgUrl:
      "http://storage.sg.content-cdn.io/cdn-cgi/image/%7Bwidth%7D,%7Bheight%7D,quality=75,format=auto/in-resources/b368029c-a4dd-448a-a888-58348cb1b144/Images/ProductImages/Source/ADFSB23775L.jpg",
    brandName: "Adidas",
    description: "Men Football Shoes",
    price: "Rs. 4200",
    size: "S, M, L, XL, XLL",
  },
];

export const WomensData = [
  {
    imgUrl:
      "https://images.unsplash.com/photo-1534653299134-96a171b61581?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=882&q=80",
    brandName: "Zara",
    description: "Female Footwear",
    price: "Rs. 2300",
    size: "M, L, XL",
  },
  {
    imgUrl:
      "https://images.unsplash.com/photo-1543163521-1bf539c55dd2?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1000&q=80",
    brandName: "Louis Vuitton",
    description: "Female Footwear",
    price: "Rs. 14500",
    size: "S, M, L",
  },
  {
    imgUrl:
      "https://images.unsplash.com/photo-1604001307862-2d953b875079?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=327&q=80",
    brandName: "Chanel",
    description: "Female Footwear",
    price: "Rs. 17900",
    size: "S, M, L, XL",
  },
];

export const kidsData = [{ imgUrl: "", brandName: "" }];
